import { toast } from "react-toastify";
import firebaseErrorMessages from "./firebaseErrors.json";

const handleError = (error) => {
  const err = error == null ? new Error("Unknown error") : error;
  const code = err && typeof err === "object" ? err.code : undefined;
  const rawMessage =
    err && typeof err === "object" && "message" in err ? err.message : undefined;

  console.log("Error code", code);
  console.log("Error message", rawMessage);

  let message;

  if (
    err &&
    typeof err === "object" &&
    err.response &&
    err.response.data &&
    err.response.data.errors
  ) {
    const errors = err.response.data.errors;

    if (typeof errors === "object" && !Array.isArray(errors)) {
      // Joi validation error
      const errorMessages = Object.values(errors).join(", ");
      message = `Validation Error: ${errorMessages}`;
    } else if (errors.global) {
      // Global error from backend
      message = errors.global;
    }
  } else if (code && firebaseErrorMessages[code]) {
    message = firebaseErrorMessages[code];
  } else if (typeof err === "string") {
    message = err;
  } else {
    message = rawMessage;
  }

  const safe =
    message && String(message).trim() !== ""
      ? String(message)
      : "Something went wrong. Please try again.";
  console.log("User-friendly Error", safe);
  toast.error(safe);
};

export default handleError;
